<script lang="ts" setup>
import { DropdownItem, Icon, Indicator } from '@brighterly/lib-lumee-ui'

import { AppRoute } from '@ts-routes/enums'

import { useSettingsStore } from '@stores/settings'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

import NotificationPointer from '@Atoms/NotificationPointer.vue'

defineOptions({
  name: 'LinkReferral',
})

const emit = defineEmits<{
  click: []
}>()

const settingsStore = useSettingsStore()

const text = 'Referrals'

const route = useRoute()
const selected = computed(() => route.path === AppRoute.Referral)
const isProgramNew = computed<boolean>(() => settingsStore.isShowNewReferralProgram)
const pointer = computed<boolean>(() => settingsStore.isShowNewReferralCredits)
const hasTrailingContent = computed<boolean>(() => isProgramNew.value || pointer.value)

const handleClick = (): void => {
  if (selected.value) return

  trackEvent(amplitudeConfig.events.clickLink, {
    name: 'link_referral',
    link_text: text,
    href: AppRoute.Referral,
  })
  emit('click')
  void navigateTo(AppRoute.Referral)
}

</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    :aria-current="selected ? 'page' : undefined"
    :selected="selected"
    @click="handleClick"
  >
    <template #leading>
      <Icon
        name="circle-dollar"
        size="md"
        color="default"
      />
    </template>
    <template
      v-if="hasTrailingContent"
      #trailingContent
    >
      <Indicator
        v-if="isProgramNew"
        view="new"
      />
      <NotificationPointer
        v-if="pointer"
        view="default"
        color="amber"
      />
    </template>
  </DropdownItem>
</template>
